import styled from 'styled-components';

export const TopRatedBanner = styled.div`
     width:100%;
     max-width:340px;
     text-align: center;
     
     @media screen and (max-width: 991px){
         max-width: 520px;
         margin: 0 auto 20px;
     }

     @media screen and (max-width: 767px){
      margin: 0 auto 10px;
     }

     img{
        width:100%;
        max-width: 300px;
        height: auto;
        display: block;
        margin: 0 auto; 
     }

     .btn-outline-success-blue{
      padding: 12px 20px;
     }
`;

export const ImageTitle = styled.h1`
   color: #01606F;
   font-family: "Jost", sans-serif;
   font-size:40px;
   font-weight: 700;
   line-height: 60px;
   margin-top:20px;
   margin-bottom:20px;

   @media screen and (max-width: 991px){
      font-size:36px;
      line-height: 50px;
   }

   @media screen and (max-width: 767px){
      font-size: 32px;
      line-height: 46px;
   }

   @media screen and (max-width: 767px){
      font-size: 26px;
      line-height: 40px;
   }

`;

